import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";

const facts = [
  "Neurolaw AI can analyze thousands of judgments in seconds.",
  "Legal AI can detect hidden precedents missed by human researchers.",
  "Neurolaw AI uses AI to match your case with the most relevant judgments.",
  "AI can now summarize 300-page judgments into just 3 key bullet points.",
  "Courts worldwide are exploring AI for faster justice delivery.",
  "Neurolaw AI reads legal language just like a trained junior lawyer.",
  "Legal AI helps eliminate bias in legal research.",
  "With AI, legal research time can drop by over 80%.",
  "AI can detect conflicting judgments across jurisdictions.",
  "Neurolaw AI uses machine learning to predict case outcomes.",
  "Legal AI can cross-reference over 1 million citations in seconds.",
  "Judges are beginning to cite AI-generated summaries in hearings.",
  "Neurolaw AI understands both statutory and case-based reasoning.",
  "AI is helping law firms reduce billable hour fatigue.",
  "Legal AI can spot fraud patterns in thousands of contracts.",
  "Neurolaw AI helps junior lawyers draft petitions 10x faster.",
  "AI can help identify violations in lease agreements automatically.",
  "Legal AI reduces clerical errors in filings and pleadings.",
  "AI is trained on thousands of real court cases to improve accuracy.",
  "Legal AI can rank judgments by their citation strength.",
  "Neurolaw AI highlights the most relevant para from every judgment.",
  "AI can differentiate between binding and persuasive precedents.",
  "Neurolaw AI detects missing legal grounds in your draft.",
  "AI helps standardize legal language across jurisdictions.",
  "Legal tech is projected to be a $37B industry by 2030.",
  "Neurolaw AI flags outdated legal provisions in your drafts.",
  "Legal AI doesn't sleep—real-time legal insights, 24/7.",
  "70% of law firms plan to integrate AI by 2027.",
  "Neurolaw AI is your research assistant that never misses a citation.",
  "AI models can now identify the legal issue from just one paragraph.",
  "Legal AI understands temporal changes in statutory interpretation.",
  "With Neurolaw AI, you can find similar cases using plain English.",
  "AI can spot logical inconsistencies in your arguments.",
  "AI can detect overruled cases before you cite them.",
  "Legal AI empowers solo lawyers to compete with large firms.",
  "Neurolaw AI learns from every interaction to serve you better.",
  "AI-powered search is more accurate than traditional keyword search.",
  "Legal AI can even identify indirect constitutional violations.",
  "Neurolaw AI helps judges and clerks streamline case backlogs.",
  "AI doesn't just search—Neurolaw understands your legal intent.",
  "Legal AI can auto-classify thousands of petitions by subject.",
  "AI is now used to detect compliance gaps in regulatory filings.",
  "Neurolaw AI can translate judgments into plain language.",
  "Legal AI reduces research anxiety for young litigators.",
  "AI is transforming access to justice across rural India.",
  "Neurolaw AI is powered by cutting-edge legal language models.",
  "Legal AI can extract arguments from scanned handwritten documents.",
  "AI-driven case recommendations improve with every use.",
  "Neurolaw AI makes complex legal workflows feel effortless.",
  "Legal intelligence is no longer manual—Neurolaw automates it."
];

const LoadingSkeleton = ({ text, mode = "fullscreen" }) => {
  const [currentFact, setCurrentFact] = useState(() => {
    const randomIndex = Math.floor(Math.random() * facts.length);
    return facts[randomIndex];
  });

  useEffect(() => {
    const factTimer = setInterval(() => {
      const randomIndex = Math.floor(Math.random() * facts.length);
      setCurrentFact(facts[randomIndex]);
    }, 5000);

    return () => clearInterval(factTimer);
  }, []);

  const isContained = mode === "contained";

  return (
    <div className={`${isContained ? "relative w-full min-h-[300px] bg-white rounded-xl" : "fixed top-0 left-0 h-screen w-full z-50 bg-white"} flex flex-col items-center justify-center ${isContained ? "p-6" : "p-10"}`}>
      {/* Loader Icon */}
      <div className={`${isContained ? "w-12 h-12 mb-4" : "w-16 h-16 mb-6"} rounded-2xl bg-gray-100 flex items-center justify-center shadow-sm`}>
        <Loader2 className={`${isContained ? "w-6 h-6" : "w-8 h-8"} text-gray-600 animate-spin`} />
      </div>

      {/* Did You Know Label */}
      <p className="font-medium text-sm text-gray-900 uppercase tracking-wider mb-2">
        {text || "Did you know?"}
      </p>

      {/* Divider */}
      <div className="w-12 h-px bg-gray-300 mb-4" />

      {/* Fact Text */}
      <p className="text-sm text-gray-600 text-center max-w-md min-h-[4.5rem] leading-relaxed">
        {currentFact}
      </p>

      {/* Subtle Loading Indicator */}
      <div className="mt-6 flex items-center gap-1.5">
        <span className="w-1.5 h-1.5 rounded-full bg-gray-400 animate-pulse" style={{ animationDelay: '0ms' }} />
        <span className="w-1.5 h-1.5 rounded-full bg-gray-400 animate-pulse" style={{ animationDelay: '150ms' }} />
        <span className="w-1.5 h-1.5 rounded-full bg-gray-400 animate-pulse" style={{ animationDelay: '300ms' }} />
      </div>
    </div>
  );
};

export default LoadingSkeleton;
